


export class DocMetadata {

    fieldName: string;
    fieldLabel: string;
    fieldValue: string
    clientId: number
    
    constructor(fieldName: string, fieldLabel: string, fieldValue: string, clientId: number) {
        
        this.fieldName = fieldName;
        this.fieldValue = fieldValue;
        this.fieldLabel = fieldLabel;
        this.clientId = clientId;
    }
}


export class DocMetadataInfo {

groups!: DocMetadataGroup[];
docMetadataByGroup!: {[group: string]: DocMetadata[]}
}

export class DocMetadataDto {
    field_label: string;
    field_name: string;
    is_multivalued?: boolean;
    is_required: boolean;
    // list of values
    lov: ValueDefinition[];
    default_value: string;

}

export class ValueDefinition {
    
    value_code: string;
    value_label: string;

}
export class DocMetadataGroup {

    groupName: string;
    isMultiValued: boolean;
    groupLabel: string;
    hasDefaultValue: boolean;
    isRequired: boolean;
}

export class DocMetadataValues {
   metadata: {[key: string]: string};
}

export type EntityType = "DOCUMENT" | "CLAIM";